module.exports={
	"Form": "PayItemEditManifest",
	"Scope": "PayItem-Edit",
	"Descriptors":
	{
		"PayItemDetails.Name":
		{
			"Name": "Name",
			"Hash": "PayItem-Edit-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 6,
				"Section": "PayItem-Edit-Identity",
				"Group": "PayItem-Edit-Identity"
			}
		},
		"PayItemDetails.ItemCode":
		{
			"Name": "Item Code",
			"Hash": "PayItem-Edit-ItemCode",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 4,
				"Section": "PayItem-Edit-Identity",
				"Group": "PayItem-Edit-Identity"
			}
		},
		"PayItemDetails.Description":
		{
			"Name": "Description",
			"Hash": "PayItem-Edit-Description",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "TextArea",
				"Row": "2",
				"Width": 12,
				"Section": "PayItem-Edit-Details",
				"Group": "PayItem-Edit-Details"
			}
		},
		"PayItemDetails.FunctionalClass":
		{
			"Name": "Functional Class",
			"Hash": "PayItem-Edit-FunctionalClass",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "3",
				"Width": 4,
				"Section": "PayItem-Edit-Details",
				"Group": "PayItem-Edit-Details"
			}
		},
		"PayItemDetails.Units":
		{
			"Name": "Units",
			"Hash": "PayItem-Edit-Units",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "3",
				"Width": 4,
				"Section": "PayItem-Edit-Details",
				"Group": "PayItem-Edit-Details"
			}
		},
		"PayItemDetails.Amount":
		{
			"Name": "Amount",
			"Hash": "PayItem-Edit-Amount",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "3",
				"Width": 4,
				"Section": "PayItem-Edit-Details",
				"Group": "PayItem-Edit-Details"
			}
		},
		"PayItemDetails.SpecificationYear":
		{
			"Name": "Specification Year",
			"Hash": "PayItem-Edit-SpecificationYear",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "4",
				"Width": 4,
				"Section": "PayItem-Edit-Details",
				"Group": "PayItem-Edit-Details"
			}
		},
		"PayItemDetails.IDTestSpecificationSet":
		{
			"Name": "Test Specification Set",
			"Hash": "PayItem-Edit-IDTestSpecificationSet",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "4",
				"Width": 4,
				"Section": "PayItem-Edit-Details",
				"Group": "PayItem-Edit-Details",
				"Entity": "TestSpecificationSet",
				"SearchFields":
				[
					"Name"
				]
			}
		},
		"PayItemDetails.Section":
		{
			"Name": "Section",
			"Hash": "PayItem-Edit-Section",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "4",
				"Width": 4,
				"Section": "PayItem-Edit-Details",
				"Group": "PayItem-Edit-Details"
			}
		},
		"PayItemDetails.ExternalPayItemID":
		{
			"Name": "External Pay Item ID",
			"Hash": "PayItem-Edit-ExternalPayItemID",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "5",
				"Width": 4,
				"Section": "PayItem-Edit-Details",
				"Group": "PayItem-Edit-Details"
			}
		},
		"PayItemDetails.FHWAEligible":
		{
			"Name": "FHWAEligible",
			"Hash": "PayItem-Edit-FHWAEligible",
			"DataType": "Boolean",
			"PictForm":
			{
				"InputType": "Boolean",
				"Row": "5",
				"Width": 3,
				"Section": "PayItem-Edit-Details",
				"Group": "PayItem-Edit-Details"
			}
		},
		"PayItemDetails.IDPayItem":
		{
			"Name": "IDPay Item",
			"Hash": "PayItem-Edit-IDPayItem",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "PayItem-Edit-DataAudit",
				"Group": "PayItem-Edit-DataAudit"
			}
		},
		"PayItemDetails.GUIDPayItem":
		{
			"Name": "GUIDPay Item",
			"Hash": "PayItem-Edit-GUIDPayItem",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "PayItem-Edit-DataAudit",
				"Group": "PayItem-Edit-DataAudit"
			}
		},
		"PayItemDetails.CreateDate":
		{
			"Name": "Create Date",
			"Hash": "PayItem-Edit-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "PayItem-Edit-DataAudit",
				"Group": "PayItem-Edit-DataAudit"
			}
		},
		"PayItemDetails.CreatingIDUser":
		{
			"Name": "Creating IDUser",
			"Hash": "PayItem-Edit-CreatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "7",
				"Width": 4,
				"Section": "PayItem-Edit-DataAudit",
				"Group": "PayItem-Edit-DataAudit"
			}
		},
		"PayItemDetails.UpdateDate":
		{
			"Name": "Update Date",
			"Hash": "PayItem-Edit-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "7",
				"Width": 4,
				"Section": "PayItem-Edit-DataAudit",
				"Group": "PayItem-Edit-DataAudit"
			}
		},
		"PayItemDetails.UpdatingIDUser":
		{
			"Name": "Updating IDUser",
			"Hash": "PayItem-Edit-UpdatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "7",
				"Width": 4,
				"Section": "PayItem-Edit-DataAudit",
				"Group": "PayItem-Edit-DataAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "PayItem-Edit-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "PayItem-Edit-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "PayItem-Edit-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "PayItem-Edit-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Data Audit",
			"Hash": "PayItem-Edit-DataAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Data Audit",
					"Hash": "PayItem-Edit-DataAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}
